import { render, staticRenderFns } from "./boards-tab.vue?vue&type=template&id=80625a2e"
import script from "./boards-tab.vue?vue&type=script&lang=js"
export * from "./boards-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports